import {Component, Input} from '@angular/core';
import {ActionSheetController, ModalController, NavController} from '@ionic/angular/lazy'
import moment from 'moment'
import {ContentService} from "../../services/content.service";
import {LangService} from "../../services/lang.service";
import {UserService} from "../../services/user.service";
import {ToastService} from "../../services/toast.service";
import {Router} from "@angular/router";
@Component({
    selector: 'app-entry-details',
    templateUrl: './entry-details.component.html',
    styleUrls: ['./entry-details.component.scss'],
    standalone: false
})
export class EntryDetailsComponent {

    @Input() entry: any;
    moods: any = {}
    selectedMood: any = {};
    formatedDate: any = "";
    articles : any = [];
    constructor(
        private modalController: ModalController,
        private navCtrl: NavController,
        private contentService: ContentService,
        private actionSheetCtrl: ActionSheetController,
        private toastService: ToastService,
        private userService: UserService,
        public lang: LangService,
        private router: Router,
    ) {
    }
    async ngOnInit() {
        this.moods = await this.contentService.getMoodsData();
        this.selectedMood = this.moods.find((mood: any) => mood.id === this.entry.mood.id);
        this.formatedDate = moment(this.entry.day).format('D MMMM YYYY');


        let articles : any = [];
        this.entry.feelingIds.forEach((feelingId: any) => {
            feelingId.articles.forEach((article: any) => {
                articles.push(article);
            })
        })

        this.articles = articles.filter((article : any, index : any, self : any) =>
            index === self.findIndex((a : any) => a.id === article.id)
        );
    }

    /**
     * Close Modal
     */
    close() {
        this.modalController.dismiss();
    }

    /**
     * Redirect to Article
     * @param slug
     */
    goToArticle(slug: string) {
        this.modalController.dismiss();
        this.navCtrl.navigateForward(`/article/` + slug, {});
    }

    /**
     * Delete Entry
     */
    async deleteEntry() {
        const actionSheet = await this.actionSheetCtrl.create({
            header: this.lang.data['action.delete_entry_title'],
            subHeader: this.lang.data['action.delete_entry_subtitle'],
            cssClass: "deleteAccount",
            buttons: [
                {
                    text: this.lang.data['action.delete_entry_confirm'],
                    role: 'destructive',
                    cssClass: "confirmDeleteAccount",
                    data: {
                        action: 'delete',
                    },
                    handler: async () => {
                        this.userService.removeEntry(this.entry.id)
                            .then(() => {
                                this.toastService.toast(
                                    this.lang.data['action.delete_entry_confirm_message'],
                                    'error',
                                    false,
                                );
                                this.close();
                            });
                    }
                },
                {
                    text: this.lang.data['action.cancel'],
                    role: 'cancel',
                    data: {
                        action: 'cancel',
                    },
                },
            ],
        });
        await actionSheet.present();

    }

    /**
     * Edit Entry Redirect
     */
    async editEntry() {
        this.close();
        await this.router.navigate(['/add-entry'], {
            queryParams: {
                day: this.entry.day,
                entryId: this.entry.id
            }
        });
    }
}
